import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Steps, Button, message, Icon, Tooltip } from 'antd';

// Import Steps
import StepOne from '../layoutComponents/customBetSteps/StepOne';
import StepTwo from '../layoutComponents/customBetSteps/StepTwo';
import StepThree from '../layoutComponents/customBetSteps/StepThree';
import StepFour from '../layoutComponents/customBetSteps/StepFour';
import StepFive from '../layoutComponents/customBetSteps/StepFive';

// API & Contract calls
import { makeCustomWager as makeCustomWagerApi } from '../../api-calls/customWagers';
import { makeCustomWager as makeContractCustomWager } from '../../contract/CustomWagersController';

Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore"])
class CustomBetModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            modalIsOpen: false,
            submittingBet: false,
            loadingMessage: ""
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleClickSubmit = this.handleClickSubmit.bind(this);
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleClickSubmit() {
        const { CustomWagerStore, UserStore, web3Store, AuthStore } = this.props;

        let self = this;
        let endTime = CustomWagerStore.newCustomWager.endTime;
        let maker = UserStore.user._id;
        let makerETHAddress = UserStore.user.publicAddress;
        let reportingEndTime = CustomWagerStore.newCustomWager.reportingEndTime;
        let value = CustomWagerStore.newCustomWager.value;
        let odds = CustomWagerStore.newCustomWager.odds;
        let outcomeOne = CustomWagerStore.newCustomWager.outcomeOne;
        let outcomeTwo = CustomWagerStore.newCustomWager.outcomeTwo;
        let judge = '0x0000000000000000000000000000000000000000'
        const wagerBytes32Id = web3Store.web3.utils.sha3(maker + endTime + reportingEndTime + (+Date.now()));
        let makerChoice = 1;
        let authToken = AuthStore.userAuth.auth.accessToken;
        const ethMultiplier = 1000000000000000000;

        this.setState({ submittingBet: true, wagerBytes32Id: wagerBytes32Id });

        return makeContractCustomWager(wagerBytes32Id, endTime, reportingEndTime, makerChoice, value, odds).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! No bet made.");
                    self.setState({ submittingBet: false });
                } else {
                    self.setState({ loadingMessage: "Transaction Accepted, Submitting Bet..." });
                    return makeCustomWagerApi(
                        authToken,
                        wagerBytes32Id,
                        maker,
                        makerETHAddress,
                        judge,
                        value,
                        odds,
                        endTime,
                        reportingEndTime,
                        outcomeOne,
                        outcomeTwo,
                        1,
                        2,
                        false,
                        false)
                        .then(() => {
                            self.next();
                            self.setState({ submittingBet: false });
                            return UserStore.updateUserBets(AuthStore.userAuth.auth.accessToken);
                        })
                }
            });
    }

    render() {
        const { CustomWagerStore } = this.props;
        const { current } = this.state;
        const Step = Steps.Step;

        const steps = [{
            title: 'Select Bet Amount & Odds',
            content: <StepOne />,
            icon: 'bank',
        }, {
            title: 'Create & Select Outcomes',
            content: <StepTwo />,
            icon: 'tool',
        }, {
            title: 'Select Bet Ending Time',
            content: <StepThree />,
            icon: 'hourglass',
        }, {
            title: 'Review & Submit',
            content: <StepFour />,
            icon: 'audit',
        }, {
            title: 'Finalize Bet',
            content: <StepFive wagerBytes32Id={this.state.wagerBytes32Id} />,
            icon: 'check',
        }];
        return (
            <div className="custom-bets-modal-open-btn">
                <button className="custom-btn-primary" onClick={this.openModal}><Icon type="plus-circle" />  New Custom Bet</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Custom Bet Modal"
                    className="custom-bet-modal"
                    overlayClassName="custom-bet-modal-overlay"
                >
                    {!this.state.submittingBet ? <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div> : null}
                    <Steps current={current} style={{ margin: '0 0 20px 0', padding: '32px 25px 25px 25px', background: 'rgba(0, 0, 0, 0.16)' }}>
                        {steps.map(item => <Step icon={<Icon type={item.icon} />} key={item.title} title={item.title} />)}
                    </Steps>
                    {!this.state.submittingBet ?
                        <div className="steps-content" style={{ margin: '0 0 20px 0', padding: '25px', background: 'rgba(0, 0, 0, 0.16)', minHeight: '50vh' }}>{steps[current].content}</div>
                        :
                        <div style={{ fontSize: '54px', textAlign: 'center', height: '40%' }}>
                            <Icon style={{ margin: '130px 0px 0px 0px' }} type='loading' />
                        </div>
                    }
                    <div className="steps-action" style={{ textAlign: 'right' }}>
                        {!this.state.submittingBet ? <div>
                            <button className="custom-btn-danger" onClick={this.closeModal}>x Cancel</button>
                            {
                                current > 0
                                && <button className="custom-btn" style={{ marginLeft: 8 }} onClick={() => this.prev()}>{"< Previous"}</button>
                            }
                            {
                                current < steps.length - 2
                                && <button className="custom-btn-primary" style={{ marginLeft: 8 }} onClick={() => this.next()}>Next ></button>
                            }
                            {
                                current === steps.length - 2 ?

                                    this.props.AuthStore.userAuth.auth ?
                                        <button className="custom-btn-success" style={{ marginLeft: 8 }} onClick={(event) => { this.handleClickSubmit() }}>$ Make Bet</button>
                                        :
                                        <Tooltip title="Login to make this bet">
                                            <button className="custom-btn-disabled" style={{ marginLeft: 8 }}>$ Make Bet</button>
                                        </Tooltip>
                                    : null}
                        </div>

                            : null}
                    </div>
                </Modal>
            </div>
        );
    }
}

export default inject('store')(observer(CustomBetModal));


// WEBPACK FOOTER //
// ./src/components/modals/CustomBetModal.js